import { Injectable } from '@angular/core';


import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from './global.service';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
  ) { }

  // getEvent() {

  //   let data = [
  //     { start: '2020-02-16', title: 'Test1', end: '2020-01-18' },
  //     { start: '2020-02-17', title: 'Test2' },
  //     { start: '2020-02-18', title: 'Test3' },
  //     {
  //       allDay: false,
  //       title: "provaTest",
  //       start: "2020-01-21 09:20:00",
  //       end: "2020-01-21 15:30:00",

        
  //     }
  //   ]

  //   return of(data);
  // }

  getEvents(token): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getEventsURL, httpOptions);
  }

  inputInstance(token, instance_id): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getInputInstance, {procces: {procces_id: 5, instance_id: instance_id}}, httpOptions);
  }

}
